module.exports = __webpack_public_path__ + "img/tapang-outline.de907cb9.png";